const sampleAddIns = [
  {
    addInId: 142,
    name: 'YK Solution',
    vendorName: 'KD Group',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 1,
    costTypeText: 'Free',
    subscriptionStatus: 1,
    subscriptionStatusText: 'Subscribed',
    addInDescription: 'YK Solution',
    vendorId: 121,
    isFavorite: false,
    ownershipType: 'enterprise',
    enterpriseName: 'Onivas Corp',
    subscriptionLifecycle: 'active',
    configurationStatus: 'configured',
    configurationDefinition: {
      fields: [
        { key: 'agencyNumber', userLabel: 'Agency Name / Number', sensitive: false },
        { key: 'username', userLabel: 'Username', sensitive: false },
        { key: 'credential', userLabel: 'Password', sensitive: true }
      ]
    },
    configurations: [
      {
        id: 'test-142-1',
        configurationName: 'AMS360',
        values: {
          agencyNumber: 'Test-12345',
          username: 'admin@test.com',
          credential: 'mock-password'
        }
      },
      {
        id: 'test-142-2',
        configurationName: 'AMS360 Backup',
        values: {
          agencyNumber: 'TEST-12346',
          username: 'ops@test.com',
          credential: 'mock-password'
        }
      }
    ],
    availableSubscriptions: [
      { addInSubscriptionId: 1420, frequency: 1, frequencyText: 'Monthly', baseValue: 0, actualValue: 0, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: true, isExpired: false, effectiveFrom: '2025-03-01', effectiveTo: '2026-03-01' }
    ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
  {
    addInId: 143,
    name: 'vxbx',
    vendorName: 'zccxz',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 2,
    costTypeText: 'Paid',
    subscriptionStatus: 1,
    subscriptionStatusText: 'Subscribed',
    addInDescription: 'xcbxbxb',
    vendorId: 110,
    isFavorite: false,
    ownershipType: 'individual',
    enterpriseName: null,
    subscriptionLifecycle: 'trial-active',
    configurationStatus: 'missing',
    availableSubscriptions: [
      { addInSubscriptionId: 2381, frequency: 1, frequencyText: 'Monthly', baseValue: 20, actualValue: 20, isRecurring: true, enableTrial: true, trialDurationDays: 14, isSubscribed: false, isExpired: false },
      { addInSubscriptionId: 2382, frequency: 2, frequencyText: 'Quarterly', baseValue: 50, actualValue: 50, isRecurring: true, enableTrial: true, trialDurationDays: 60, isSubscribed: false, isExpired: false },
      { addInSubscriptionId: 2383, frequency: 3, frequencyText: 'Semi Annual', baseValue: 100, actualValue: 100, isRecurring: true, enableTrial: true, trialDurationDays: 60, isSubscribed: true, isExpired: false, effectiveFrom: '2025-10-01', effectiveTo: '2026-06-01' },
      { addInSubscriptionId: 2384, frequency: 4, frequencyText: 'Annual', baseValue: 220, actualValue: 220, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false },
      { addInSubscriptionId: 2385, frequency: 99, frequencyText: 'One-Time', baseValue: 120, actualValue: 120, isRecurring: false, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false }
    ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
  {
    addInId: 141,
    name: 'Test solution for amit',
    vendorName: 'amit',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 2,
    costTypeText: 'Paid',
    subscriptionStatus: 0,
    subscriptionStatusText: 'Not Purchased',
    addInDescription: 'test desc',
    vendorId: 43,
    isFavorite: false,
    availableSubscriptions: [ { addInSubscriptionId: 2380, frequency: 3, frequencyText: 'Semi Annual', baseValue: 560, actualValue: 560, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false } ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
   {
    addInId: 5213,
    name: 'Test solution for Nick',
    vendorName: 'amit',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 2,
    costTypeText: 'Paid',
    subscriptionStatus: 0,
    subscriptionStatusText: 'Not Purchased',
    addInDescription: 'test desc',
    vendorId: 43,
    isFavorite: false,
    availableSubscriptions: [ { addInSubscriptionId: 2381, frequency: 1, frequencyText: 'Monthly', baseValue: 120, actualValue: 120, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false },
      { addInSubscriptionId: 2382, frequency: 2, frequencyText: 'Quarterly', baseValue: 120, actualValue: 120, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false },
      { addInSubscriptionId: 2383, frequency: 3, frequencyText: 'Semi Annual', baseValue: 560, actualValue: 560, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false },
      { addInSubscriptionId: 2384, frequency: 4, frequencyText: 'Annual', baseValue: 1120, actualValue: 1120, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false },
      { addInSubscriptionId: 2385, frequency: 99, frequencyText: 'One-Time', baseValue: 120, actualValue: 120, isRecurring: false, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false } 
     ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
  {
    addInId: 131,
    name: 'Sample Key WSD',
    vendorName: 'Vertafore',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 2,
    costTypeText: 'Paid',
    subscriptionStatus: 1,
    subscriptionStatusText: 'Subscribed',
    addInDescription: 'Sample Key WSD desc',
    vendorId: 115,
    isFavorite: false,
    ownershipType: 'enterprise',
    enterpriseName: 'Northwind Brokers',
    subscriptionLifecycle: 'expired',
    configurationStatus: 'configured',
    availableSubscriptions: [ { addInSubscriptionId: 2360, frequency: 3, frequencyText: 'Semi Annual', baseValue: 71, actualValue: 710, isRecurring: false, enableTrial: false, trialDurationDays: null, isSubscribed: true, isExpired: true, effectiveFrom: '2024-01-01', effectiveTo: '2024-07-01' } ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
  {
    addInId: 135,
    name: 'Annual',
    vendorName: 'AAAAjay',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 2,
    costTypeText: 'Paid',
    subscriptionStatus: 1,
    subscriptionStatusText: 'Subscribed',
    addInDescription: 'Annual',
    vendorId: 9,
    isFavorite: false,
    ownershipType: 'individual',
    enterpriseName: null,
    subscriptionLifecycle: 'active',
    configurationStatus: 'configured',
    configurationDefinition: {
      fields: [
        { key: 'agencyNumber', userLabel: 'Agency Name / Number', sensitive: false },
        { key: 'username', userLabel: 'Username', sensitive: false },
        { key: 'credential', userLabel: 'Password', sensitive: true }
      ]
    },
    configurations: [
      {
        id: 'cfg-135-1',
        configurationName: 'Primary Config',
        values: {
          agencyNumber: 'AG-22222',
          username: 'annual@agency.com',
          credential: 'demo-secret-3'
        }
      }
    ],
    availableSubscriptions: [ { addInSubscriptionId: 2364, frequency: 1, frequencyText: 'Monthly', baseValue: 10, actualValue: 10, isRecurring: true, enableTrial: true, trialDurationDays: 14, isSubscribed: true, isExpired: false, effectiveFrom: '2026-01-15', effectiveTo: '2027-01-15' }, { addInSubscriptionId: 2376, frequency: 3, frequencyText: 'Semi Annual', baseValue: 560, actualValue: 560, isRecurring: true, enableTrial: true, trialDurationDays: 14, isSubscribed: false, isExpired: false }, { addInSubscriptionId: 2377, frequency: 99, frequencyText: 'One-Time', baseValue: 560, actualValue: 560, isRecurring: false, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false } ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
  {
    addInId: 144,
    name: 'aaA',
    vendorName: 'Vertafore',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 1,
    costTypeText: 'Free',
    subscriptionStatus: 1,
    subscriptionStatusText: 'Subscribed',
    addInDescription: 'AAA',
    vendorId: 108,
    isFavorite: false,
    ownershipType: 'enterprise',
    enterpriseName: 'BlueSky Group',
    subscriptionLifecycle: 'trial-active',
    configurationStatus: 'missing',
    availableSubscriptions: [
      { addInSubscriptionId: 2365, frequency: 1, frequencyText: 'Monthly', baseValue: 0, actualValue: 0, isRecurring: true, enableTrial: true, trialDurationDays: 7, isSubscribed: true, isExpired: false, effectiveFrom: '2025-12-01', effectiveTo: '2026-01-01' }
    ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  }
  ,
  {
    addInId: 6001,
    name: 'Freq One Add-in',
    vendorName: 'Vendor One',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 2,
    costTypeText: 'Paid',
    subscriptionStatus: 0,
    subscriptionStatusText: 'Not Purchased',
    addInDescription: 'Monthly option',
    vendorId: 201,
    isFavorite: false,
    availableSubscriptions: [ { addInSubscriptionId: 60011, frequency: 1, frequencyText: 'Monthly', baseValue: 10, actualValue: 10, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false } ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
  {
    addInId: 6002,
    name: 'Freq Two Add-in',
    vendorName: 'Vendor Two',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 2,
    costTypeText: 'Paid',
    subscriptionStatus: 0,
    subscriptionStatusText: 'Not Purchased',
    addInDescription: 'Quarterly option',
    vendorId: 202,
    isFavorite: false,
    availableSubscriptions: [ { addInSubscriptionId: 60021, frequency: 2, frequencyText: 'Quarterly', baseValue: 25, actualValue: 25, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false } ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
  {
    addInId: 6003,
    name: 'Freq Three Add-in',
    vendorName: 'Vendor Three',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 2,
    costTypeText: 'Paid',
    subscriptionStatus: 0,
    subscriptionStatusText: 'Not Purchased',
    addInDescription: 'Semi Annual option',
    vendorId: 203,
    isFavorite: false,
    availableSubscriptions: [ { addInSubscriptionId: 60031, frequency: 3, frequencyText: 'Semi Annual', baseValue: 60, actualValue: 60, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false } ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
  {
    addInId: 6004,
    name: 'Freq Four Add-in',
    vendorName: 'Vendor Four',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 2,
    costTypeText: 'Paid',
    subscriptionStatus: 0,
    subscriptionStatusText: 'Not Purchased',
    addInDescription: 'Annual option',
    vendorId: 204,
    isFavorite: false,
    availableSubscriptions: [ { addInSubscriptionId: 60041, frequency: 4, frequencyText: 'Annual', baseValue: 200, actualValue: 200, isRecurring: true, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false } ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
  {
    addInId: 6005,
    name: 'One-Time Add-in',
    vendorName: 'Vendor Five',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 2,
    costTypeText: 'Paid',
    subscriptionStatus: 0,
    subscriptionStatusText: 'Not Purchased',
    addInDescription: 'One-time purchase option',
    vendorId: 205,
    isFavorite: false,
    availableSubscriptions: [ { addInSubscriptionId: 60051, frequency: 99, frequencyText: 'One-Time', baseValue: 75, actualValue: 75, isRecurring: false, enableTrial: false, trialDurationDays: null, isSubscribed: false, isExpired: false } ],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  },
  {
    addInId: 6006,
    name: 'Free Sample Add-in',
    vendorName: 'Free Vendor',
    addInType: 1,
    addInTypeText: 'Individual',
    costType: 1,
    costTypeText: 'Free',
    subscriptionStatus: 0,
    subscriptionStatusText: 'Not Purchased',
    addInDescription: 'Free add-in for testing',
    vendorId: 206,
    isFavorite: false,
    availableSubscriptions: [],
    totalCartItems: 0,
    published: true,
    applicableToSubscriber: true
  }
];

export function fetchAddIns() {
  return new Promise((resolve) => {
    setTimeout(() => resolve(structuredClone(sampleAddIns)), 300);
  });
}

export default { fetchAddIns };
